import React from 'react';
import PropTypes from 'prop-types';

const Repeater = ({ times, children }) => {
  if (!children) return null;
  const items = [...Array(times).keys()];
  return <>{items.map(i => ({ ...children, key: i }))}</>;
};

Repeater.defaultProps = {
  children: null,
};

Repeater.propTypes = {
  times: PropTypes.number.isRequired,
  children: PropTypes.node,
};

export default Repeater;
